/* Version: 3.5.137 */
'use client';
import 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

var alertIcon = (function (_ref) {
  var alt = _ref.alt;
  return /*#__PURE__*/jsxs("svg", {
    width: "19px",
    height: "19px",
    focusable: "false",
    viewBox: "0 0 4 19",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/jsx("title", {
      children: alt
    }), /*#__PURE__*/jsx("g", {
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/jsx("g", {
        transform: "translate(-258.000000, -6037.000000)",
        fill: "#FFFFFF",
        fillRule: "nonzero",
        children: /*#__PURE__*/jsx("g", {
          transform: "translate(240.000000, 6026.000000)",
          children: /*#__PURE__*/jsx("path", {
            d: "M18,25.25 L21.8,25.25 L21.8,29.05 L18,29.05 L18,25.25 Z M18,11 L21.8,11 L21.8,22.4 L18,22.4 L18,11 Z"
          })
        })
      })
    })]
  });
});

export { alertIcon as default };
